export * from "./Text.settings";
